import { buildApiUrl } from "../helpers/base_url";

export async function createServiceEngagement(payload: {
  clientId: number;
  businessServiceId: number;
  inquiryMessage: string;
  preferredServiceDate: string; // ISO string
  estimatedPrice?: number;
  currency: string;
}) {
  const accessToken = localStorage.getItem("accessToken");
  const response = await fetch(buildApiUrl("/api/service-engagements"), {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${accessToken}`,
    },
    body: JSON.stringify(payload),
  });
  if (!response.ok) {
    throw new Error("Failed to create engagement");
  }
  return response.json();
}

export async function getClientVendorEngagement(
  clientId: number,
  vendorId: number
) {
  const accessToken = localStorage.getItem("accessToken");
  const response = await fetch(
    `${buildApiUrl(
      `/api/service-engagements/client/${clientId}/vendor/${vendorId}/paginated`
    )}?page=&size=`,
    {
      method: "GET",
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    }
  );
  if (!response.ok) {
    throw new Error("Failed to fetch engagement");
  }
  return response.json();
}

export async function getEngagementChatHistory(
  engagementId: number,
  page = 0,
  size = 20
) {
  const accessToken = localStorage.getItem("accessToken");
  const url = new URL(
    buildApiUrl(`/api/messages/engagement/${engagementId}`)
  );
  url.searchParams.set("page", String(page));
  url.searchParams.set("size", String(size));
  const response = await fetch(url.toString(), {
    method: "GET",
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });
  if (!response.ok) {
    throw new Error("Failed to fetch chat history");
  }
  return response.json();
}

export async function postClientReview(
  clientId: number,
  review: {
    serviceEngagementId: number;
    rating: number;
    serviceQualityRating: number;
    communicationRating: number;
    valueForMoneyRating: number;
    comment: string;
    wouldRecommend: boolean;
  }
) {
  const accessToken = localStorage.getItem("accessToken");
  const response = await fetch(
    buildApiUrl(`/api/reviews/client/${clientId}`),
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
      body: JSON.stringify(review),
    }
  );
  if (!response.ok) {
    throw new Error("Failed to submit review");
  }
  return response.json();
}
